import { linePlot, periodInput } from "../definitionHelpers";
import { PALETTE } from "../palette";
import { fillDirectionalMovement } from "../math/directionalMovement";

/**
 * ADX (research §1.4), as TV Directional Movement Index (its ADX, +DI and
 * −DI plots; TV Average Directional Index gives the same ADX once warmed up).
 */
export default {
  id: "adx",
  name: "ADX",
  isOscillator: true,
  decimals: 2,
  inputs: [
    periodInput("adxSmoothing", "ADX Smoothing", 14, { max: 100 }),
    periodInput("diLength", "DI Length", 14, { max: 100 }),
  ],
  plots: [
    linePlot("adx", "ADX", PALETTE.PUMPKIN),
    linePlot("plusDi", "+DI", PALETTE.AQUA),
    linePlot("minusDi", "−DI", PALETTE.YELLOW),
  ],
  buffers: ["atr", "plusMove", "minusMove", "dx"],
  levels: [],

  calculate: (bars, { adxSmoothing, diLength }, series, fromIndex) => {
    fillDirectionalMovement({ bars, diLength, adxSmoothing, series, fromIndex });
  },
};
